export function trackHotjarEvent(eventName: string): void {
  if (typeof window === "undefined" || typeof window.hj !== "function") {
    return;
  }

  try {
    window.hj("event", eventName);
  } catch (error) {
    console.error("Hotjar fire event error:", error);
  }
}
